import type { L10n } from './i18n';

/**
 * Platforma modullari (bounded context). Har modul:
 *  - o'z PostgreSQL sxemasiga ega (`identity.*`, `catalog.*`, ...) — boshqa modul jadvaliga FK yo'q;
 *  - kelajakda alohida servis + alohida bazaga ko'chiriladi (DATABASE_URL_<MODUL>).
 */
export const MODULES = [
  'identity',
  'org',
  'catalog',
  'wms',
  'oms',
  'delivery',
  'finance',
  'hr',
  'support',
  'integrations',
  'analytics',
  'system',
] as const;
export type ModuleKey = (typeof MODULES)[number];

export const MODULE_TITLES: Record<ModuleKey, L10n> = {
  identity: { uz: 'Foydalanuvchilar va kirish', ru: 'Пользователи и доступ' },
  org: { uz: 'Hamkorlar va tashkilot', ru: 'Партнёры и организация' },
  catalog: { uz: 'Katalog', ru: 'Каталог' },
  wms: { uz: 'Ombor', ru: 'Склад' },
  oms: { uz: 'Buyurtmalar', ru: 'Заказы' },
  delivery: { uz: 'Yetkazib berish', ru: 'Доставка' },
  finance: { uz: 'Moliya va buxgalteriya', ru: 'Финансы и бухгалтерия' },
  hr: { uz: 'Xodimlar (HR)', ru: 'Сотрудники (HR)' },
  support: { uz: 'Call-markaz', ru: 'Колл-центр' },
  integrations: { uz: 'Integratsiyalar', ru: 'Интеграции' },
  analytics: { uz: 'Analitika', ru: 'Аналитика' },
  system: { uz: 'Tizim', ru: 'Система' },
};

/** Tashkilot turi: platforma (Keytosell o'zi) yoki hamkor (seller). */
export const ORG_KINDS = ['platform', 'seller'] as const;
export type OrgKind = (typeof ORG_KINDS)[number];

/**
 * Portal: W — Work (xodimlar, back-office), S — Seller (hamkor kabineti).
 * Tashkilot turidan kelib chiqadi: platform → work, seller → seller.
 */
export type Portal = 'work' | 'seller';
export const portalOf = (kind: OrgKind): Portal => (kind === 'platform' ? 'work' : 'seller');

/** Mijoz ilovalari — sessiyada qayd etiladi. */
export const CLIENT_APPS = ['web', 'app-w', 'app-s', 'print'] as const;
export type ClientApp = (typeof CLIENT_APPS)[number];

/** Biznes vaqt zonasi — kun chegaralari, hisobotlar, smenalar. */
export const BUSINESS_TZ = 'Asia/Tashkent';
export const BUSINESS_TZ_OFFSET_MIN = 300;
